<template>
  <super-admin-layout>
    <v-container fluid>
      <v-row>
        <v-col md="12">
          <v-card>
            <v-tabs v-model="tab" grow>
              <v-tab v-for="item in items" :key="item" :href="'#' + item">
                {{ item }}
              </v-tab>
            </v-tabs>
            <v-tabs-items v-model="tab">
              <v-tab-item
                v-if="['Level 1','Level 2', 'Tier 1', 'Tier 2'].includes(partner.partner_level)"     
                :transition="false"
                :reverse-transition="false"
                key="Details"
                id="Details"
              >
                <v-card
                  v-if="['Level 1','Level 2', 'Tier 1', 'Tier 2'].includes(partner.partner_level)"     
                  flat
                  class="text-left"
                >
                  <Details />
                </v-card>
              </v-tab-item>
              <v-tab-item     
                :transition="false"
                :reverse-transition="false"
                key="PartnerUsers"
                id="Account Managers"
                v-if="$globalConfig.APP_NAME == 'partner'"     
              >
                <PartnerUsers :userId="this.partner.user_id"  v-if="$globalConfig.APP_NAME == 'partner'"/>
                </v-tab-item>
              <v-tab-item
              v-if="['Level 1','Level 2', 'Tier 1', 'Tier 2'].includes(partner.partner_level)"     
                :transition="false"
                :reverse-transition="false"
                key="Users"
                id="Customers"
              >
                <Users />
              </v-tab-item>
              <v-tab-item
              v-if="['Level 1', 'Tier 1'].includes(partner.partner_level) && $globalConfig.APP_NAME == 'senso'"     
                :transition="false"
                :reverse-transition="false"
                key="Tier two Partners"
                id="Tier Two Partners"
              >
                <v-card
                v-if="['Level 1', 'Tier 1'].includes(partner.partner_level) && $globalConfig.APP_NAME == 'senso'"     
                  flat
                  class="text-left"
                >
                  <Tier2Partners :userId="partnerId" />
                </v-card>
              </v-tab-item>
              <v-tab-item
                :transition="false"
                :reverse-transition="false"
                key="Settings"
                id="Settings"
              >
                <v-card flat class="text-left">
                  <Customization />
                </v-card>
              </v-tab-item>
            </v-tabs-items>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </super-admin-layout>
</template>

<script>
import SuperAdminLayout from '@/layouts/SuperAdmin';
//import companyAPI from "@/api/company.js";
import partnerAPI from '@/api/partner.js';
import Details from '@/components/superadmin/partners/Details';
import Tier2Partners from '@/components/superadmin/partners/Tier2Partners';
import Users from '@/components/superadmin/partners/Users';
import PartnerUsers from '@/components/superadmin/partners/PartnerUsers';
import Customization from '@/components/partner/Customization';

export default {
  name: 'SuperAdminCompanyDetails',
  components: {
    SuperAdminLayout,
    Details,
    Users,
    Tier2Partners,
    PartnerUsers,
    Customization
  },
  data() {
    return {
      partner: [],
      partnerInfo: [],
      loading: false,
      tab: null,
      items: [],
      partnerId: this.$route.params.id,
      params: '',
      searchParams: '',
    };
  },
  mounted() {
    this.getPartnerData();
  },
  methods: {
    getPartnerData() {
      this.loading = true;
      partnerAPI.getPartnerByID(this.partnerId).then((resp) => {
        this.partner = resp.data.data;
        if (['Level 1', 'Tier 1'].includes(this.partner.partner_level) && this.$globalConfig.APP_NAME == 'senso') {
          this.items = ['Details', 'Customers', 'Tier Two Partners', 'Settings'];
        } else {
          this.items = ['Details', 'Account Managers' ,'Customers', 'Settings'];
        }
        this.loading = false;
      });
    },
  },
};
</script>
